/**
 * Sanitize a label for use in a download filename (filesystem-safe, readable).
 */
export const sanitizeInvoiceCsvFilenamePart = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return 'unknown';
  }

  return trimmed
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

export type InvoiceCsvFilenameType = 'eligible' | 'ineligible' | 'adjustments';

/**
 * Invoice Central: `{makerName}-{currency}-{invoiceType}-invoices.csv`
 * e.g. Walmart-USD-eligible-invoices.csv
 */
export const buildInvoiceCentralCsvFilename = ({
  makerName,
  currency,
  invoiceType,
}: {
  makerName: string;
  currency: string;
  invoiceType: InvoiceCsvFilenameType;
}): string => {
  const maker = sanitizeInvoiceCsvFilenamePart(makerName);
  const curr = sanitizeInvoiceCsvFilenamePart(currency);
  return `${maker}-${curr}-${invoiceType}-invoices.csv`;
};

/**
 * Division: `{makerName}-{divisionId}-eligible-invoices.csv`
 * e.g. Walmart-3563054-eligible-invoices.csv
 * (Same pattern for locked/adjustment when those division menus migrate.)
 */
export const buildDivisionInvoiceCsvFilename = ({
  makerName,
  divisionId,
  invoiceType = 'eligible',
}: {
  makerName: string;
  divisionId: string | number;
  invoiceType?: InvoiceCsvFilenameType;
}): string => {
  const maker = sanitizeInvoiceCsvFilenamePart(makerName);
  const division = sanitizeInvoiceCsvFilenamePart(String(divisionId));
  return `${maker}-${division}-${invoiceType}-invoices.csv`;
};
